import React from 'react';
import teamPhoto from '../../assets/images/Janelle and Melissa Brick Wall_2.jpg';
import InfoCardGroup from '../InfoCardGroup';
import Page from '../Page';
import './style.css';

export const Homepage = () => {
  return (
    <Page
      id='homepage'
      className='landing'
      title='Counseling Services'
      description='Interconnections Counseling provides therapy for adults, couples, and families with telehealth appointments.'>
      <div className='background__banner'>
        <div className='banner__overlay'>
          <h3>
            The definition of interconnection is to be meaningfully related, or
            simply, to connect with one another.
            <br />
            <span className='bold-mission'>
              Our mission is to foster interconnections through collaborative
              therapy.
            </span>
          </h3>
        </div>
      </div>
      <div className='banner'>
        <img
          className='banner__img'
          src={teamPhoto}
          alt='Melissa Pizzo and Janelle Kramer'
        />
      </div>
      <section className='homepage__intro'>
        <h2>Care that meets you where you are</h2>
        <p>
          We provide counseling for adults, couples, and families, with a focus
          on addictions, relationships, and maternal mental health. Sessions are
          offered virtually to make care accessible and consistent.
        </p>
        <a className='banner__call-to-action' href='/contact'>
          Contact Us
        </a>
      </section>
      <InfoCardGroup style={{ position: 'relative', bottom: '15px' }} />
    </Page>
  );
};

export default Homepage;
